// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-72a1eed6] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.avatardiv[data-v-72a1eed6] {
  position: relative;
  display: inline-block;
  width: var(--avatar-size);
  height: var(--avatar-size);
}
.avatardiv--unknown[data-v-72a1eed6] {
  position: relative;
  background-color: var(--color-main-background);
  white-space: normal;
}
.avatardiv[data-v-72a1eed6]:not(.avatardiv--unknown) {
  background-color: var(--color-main-background) !important;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05) inset;
}
.avatardiv--with-menu[data-v-72a1eed6] {
  cursor: pointer;
}
.avatardiv--with-menu .action-item[data-v-72a1eed6] {
  position: absolute;
  top: 0;
  inset-inline-start: 0;
}
.avatardiv--with-menu[data-v-72a1eed6] .action-item__menutoggle {
  cursor: pointer;
  opacity: 0;
}
.avatardiv--with-menu[data-v-72a1eed6]:focus-within .action-item__menutoggle, .avatardiv--with-menu[data-v-72a1eed6]:hover .action-item__menutoggle, .avatardiv--with-menu.avatardiv--with-menu-loading[data-v-72a1eed6] .action-item__menutoggle {
  opacity: 1;
}
.avatardiv--with-menu:focus-within img[data-v-72a1eed6], .avatardiv--with-menu:hover img[data-v-72a1eed6], .avatardiv--with-menu.avatardiv--with-menu-loading img[data-v-72a1eed6] {
  opacity: 0.3;
}
.avatardiv--with-menu[data-v-72a1eed6] .action-item__menutoggle,
.avatardiv--with-menu img[data-v-72a1eed6] {
  transition: opacity var(--animation-quick);
}
.avatardiv--with-menu[data-v-72a1eed6]  .button-vue,
.avatardiv--with-menu[data-v-72a1eed6]  .button-vue__icon {
  height: var(--avatar-size);
  min-height: var(--avatar-size);
  width: var(--avatar-size) !important;
  min-width: var(--avatar-size);
}
.avatardiv--with-menu[data-v-72a1eed6] >  .button-vue, .avatardiv--with-menu[data-v-72a1eed6] >  .action-item .button-vue {
  --button-radius: calc(var(--avatar-size) / 2);
}
.avatardiv .avatardiv__initials-wrapper[data-v-72a1eed6] {
  display: block;
  height: var(--avatar-size);
  width: var(--avatar-size);
  background-color: var(--color-main-background);
  border-radius: calc(var(--avatar-size) / 2);
}
.avatardiv .avatardiv__initials-wrapper .avatardiv__initials[data-v-72a1eed6] {
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  display: block;
  width: 100%;
  text-align: center;
  font-weight: normal;
}
.avatardiv img[data-v-72a1eed6] {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.avatardiv .material-design-icon[data-v-72a1eed6] {
  width: var(--avatar-size);
  height: var(--avatar-size);
}
.avatardiv .avatardiv__user-status[data-v-72a1eed6] {
  --avatar-status-size-orbital: calc(var(--avatar-size) * (1 - 1 / sqrt(2)));
  --avatar-status-size-min: var(--font-size-small);
  --avatar-status-size: max(var(--avatar-status-size-orbital), var(--avatar-status-size-min));
  box-sizing: border-box;
  position: absolute;
  inset-inline-end: 0;
  inset-block-end: 0;
  height: var(--avatar-status-size);
  width: var(--avatar-status-size);
  line-height: 1;
  font-size: calc(var(--avatar-status-size) / 1.2);
  background-color: var(--color-main-background);
  background-repeat: no-repeat;
  background-size: var(--avatar-status-size);
  background-position: center;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.acli:hover .avatardiv .avatardiv__user-status[data-v-72a1eed6] {
  border-color: var(--color-background-hover);
  background-color: var(--color-background-hover);
}
.acli.active .avatardiv .avatardiv__user-status[data-v-72a1eed6] {
  border-color: var(--color-primary-element-light);
  background-color: var(--color-primary-element-light);
}
.avatardiv .avatardiv__user-status--icon[data-v-72a1eed6] {
  border: none;
  background-color: transparent;
}
.avatardiv .popovermenu-wrapper[data-v-72a1eed6] {
  position: relative;
  display: inline-block;
}
.avatar-class-icon[data-v-72a1eed6] {
  display: block;
  border-radius: calc(var(--avatar-size) / 2);
  background-color: var(--color-background-darker);
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/node_modules/@nextcloud/vue/dist/assets/NcAvatar-CuPj3fbb.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,yDAAyD;EACzD,6CAA6C;AAC/C;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,qBAAqB;AACvB;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,0BAA0B;EAC1B,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,yBAAyB;EACzB,8CAA8C;EAC9C,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,0EAA0E;EAC1E,gDAAgD;EAChD,2FAA2F;EAC3F,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,gCAAgC;EAChC,cAAc;EACd,gDAAgD;EAChD,8CAA8C;EAC9C,4BAA4B;EAC5B,0CAA0C;EAC1C,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2CAA2C;EAC3C,+CAA+C;AACjD;AACA;EACE,gDAAgD;EAChD,oDAAoD;AACtD;AACA;EACE,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,2CAA2C;EAC3C,gDAAgD;EAChD,YAAY;AACd","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-72a1eed6] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.avatardiv[data-v-72a1eed6] {\n  position: relative;\n  display: inline-block;\n  width: var(--avatar-size);\n  height: var(--avatar-size);\n}\n.avatardiv--unknown[data-v-72a1eed6] {\n  position: relative;\n  background-color: var(--color-main-background);\n  white-space: normal;\n}\n.avatardiv[data-v-72a1eed6]:not(.avatardiv--unknown) {\n  background-color: var(--color-main-background) !important;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05) inset;\n}\n.avatardiv--with-menu[data-v-72a1eed6] {\n  cursor: pointer;\n}\n.avatardiv--with-menu .action-item[data-v-72a1eed6] {\n  position: absolute;\n  top: 0;\n  inset-inline-start: 0;\n}\n.avatardiv--with-menu[data-v-72a1eed6] .action-item__menutoggle {\n  cursor: pointer;\n  opacity: 0;\n}\n.avatardiv--with-menu[data-v-72a1eed6]:focus-within .action-item__menutoggle, .avatardiv--with-menu[data-v-72a1eed6]:hover .action-item__menutoggle, .avatardiv--with-menu.avatardiv--with-menu-loading[data-v-72a1eed6] .action-item__menutoggle {\n  opacity: 1;\n}\n.avatardiv--with-menu:focus-within img[data-v-72a1eed6], .avatardiv--with-menu:hover img[data-v-72a1eed6], .avatardiv--with-menu.avatardiv--with-menu-loading img[data-v-72a1eed6] {\n  opacity: 0.3;\n}\n.avatardiv--with-menu[data-v-72a1eed6] .action-item__menutoggle,\n.avatardiv--with-menu img[data-v-72a1eed6] {\n  transition: opacity var(--animation-quick);\n}\n.avatardiv--with-menu[data-v-72a1eed6]  .button-vue,\n.avatardiv--with-menu[data-v-72a1eed6]  .button-vue__icon {\n  height: var(--avatar-size);\n  min-height: var(--avatar-size);\n  width: var(--avatar-size) !important;\n  min-width: var(--avatar-size);\n}\n.avatardiv--with-menu[data-v-72a1eed6] >  .button-vue, .avatardiv--with-menu[data-v-72a1eed6] >  .action-item .button-vue {\n  --button-radius: calc(var(--avatar-size) / 2);\n}\n.avatardiv .avatardiv__initials-wrapper[data-v-72a1eed6] {\n  display: block;\n  height: var(--avatar-size);\n  width: var(--avatar-size);\n  background-color: var(--color-main-background);\n  border-radius: calc(var(--avatar-size) / 2);\n}\n.avatardiv .avatardiv__initials-wrapper .avatardiv__initials[data-v-72a1eed6] {\n  position: absolute;\n  top: 0;\n  inset-inline-start: 0;\n  display: block;\n  width: 100%;\n  text-align: center;\n  font-weight: normal;\n}\n.avatardiv img[data-v-72a1eed6] {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.avatardiv .material-design-icon[data-v-72a1eed6] {\n  width: var(--avatar-size);\n  height: var(--avatar-size);\n}\n.avatardiv .avatardiv__user-status[data-v-72a1eed6] {\n  --avatar-status-size-orbital: calc(var(--avatar-size) * (1 - 1 / sqrt(2)));\n  --avatar-status-size-min: var(--font-size-small);\n  --avatar-status-size: max(var(--avatar-status-size-orbital), var(--avatar-status-size-min));\n  box-sizing: border-box;\n  position: absolute;\n  inset-inline-end: 0;\n  inset-block-end: 0;\n  height: var(--avatar-status-size);\n  width: var(--avatar-status-size);\n  line-height: 1;\n  font-size: calc(var(--avatar-status-size) / 1.2);\n  background-color: var(--color-main-background);\n  background-repeat: no-repeat;\n  background-size: var(--avatar-status-size);\n  background-position: center;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.acli:hover .avatardiv .avatardiv__user-status[data-v-72a1eed6] {\n  border-color: var(--color-background-hover);\n  background-color: var(--color-background-hover);\n}\n.acli.active .avatardiv .avatardiv__user-status[data-v-72a1eed6] {\n  border-color: var(--color-primary-element-light);\n  background-color: var(--color-primary-element-light);\n}\n.avatardiv .avatardiv__user-status--icon[data-v-72a1eed6] {\n  border: none;\n  background-color: transparent;\n}\n.avatardiv .popovermenu-wrapper[data-v-72a1eed6] {\n  position: relative;\n  display: inline-block;\n}\n.avatar-class-icon[data-v-72a1eed6] {\n  display: block;\n  border-radius: calc(var(--avatar-size) / 2);\n  background-color: var(--color-background-darker);\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
